import { UsersMeResponse } from '../types';
import { ApiConfig } from './types';

const UsersApi = ({ baseUrl, fetchWithToken }: ApiConfig) => {
  return {
    me(): Promise<UsersMeResponse> {
      const url = `${baseUrl}/users/me`;
      return fetchWithToken<UsersMeResponse>(url);
    },
    canCreate(): Promise<boolean> {
      return this.me()
        .then((response) => !!response?.permittedActions?.createRfi)
        .catch(() => false);
    },
  };
};

export default UsersApi;
